<template>
  <block component-name="block-text-counter">
    <div
      class="grid tablet:grid-cols-4 w-full desktop:max-w-[82vw] mx-auto"
      :class="{
        'grid-cols-3': $attrs.data.body.items.length <= 3,
        'grid-cols-2': $attrs.data.body.items.length === 4,
        'gap-4xl': $attrs.data.body.items.length === 2,
        'gap-lg': $attrs.data.body.items.length > 2,
      }"
    >
      <txt-counter
        v-for="item in $attrs.data.body.items"
        :count="item.count"
        :title="item.title"
        :use-math-symbol="item.useMathSymbol === false ? false : true"
        :use-percent="item.usePercent || false"
        class="col-span-1 w-full"
      />
    </div>
  </block>
</template>
